<template>
	<div class="PageBox">
		<div class="page_box">
			<div id="page_turn_box">
				<li v-for="(item,index) in pageBoxData" :key='index'>
					<router-link :to='item.Url' :class="[ (pageIndex==item.Nab ||(!pageIndex&&item.Nab==1))?'on':'']"  >{{item.Name}}</router-link>
				</li>    
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'PageBox',
		props:{
			pageBoxData:{
				type: Object,
				default: () => {}
			},
			pageIndex: {
			   type:Number,
			   default: 1
			 }
		}
	}
</script>

<style lang="less" scoped="scoped">
.PageBox{
	height: auto;
	margin-bottom: 70px;
	font-size: 0px;
	.page_box {
		li{
			margin: 0 20px;
			a{
				font-size: 18px;
				font-weight: normal;
				font-stretch: normal;
				letter-spacing: 2px;
				color: #333333;
				margin-top: 40px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/pageBox.vue